(function () {
  function applePayAvailable() {
    try {
      return (
        window.ApplePaySession &&
        typeof window.ApplePaySession.canMakePayments === "function" &&
        window.ApplePaySession.canMakePayments()
      );
    } catch (e) {
      return false;
    }
  }

  function countTopLevelButtons(container) {
    // Count only real element children inside the clea nslate wrapper
    const wrap = container.querySelector(".shopify-cleanslate > div");
    if (!wrap) return 0;

    return Array.from(wrap.children).filter((el) => {
      // ignore empty nodes (just in case)
      return el && el.nodeType === 1 && el.offsetParent !== null;
    }).length;
  }

  function applyLayout(container) {
    if (!container) return;

    container.classList.remove("is-two-up", "is-single");

    const buttonsCount = countTopLevelButtons(container);
    const hasApplePay = applePayAvailable();

    // Your rule:
    // - If Apple Pay is available AND (at least 2 buttons rendered) -> two-up grid
    // - Otherwise -> single full width
    if (hasApplePay && buttonsCount >= 2) {
      container.classList.add("is-two-up");
    } else {
      container.classList.add("is-single");
    }
  }

  function initAll() {
    document
      .querySelectorAll(".additional-checkout-buttons")
      .forEach(applyLayout);
  }

  // Run on load
  document.addEventListener("DOMContentLoaded", initAll);

  // Re-run when cart drawer updates (AJAX/sections/merge updates)
  // MutationObserver is the most theme-agnostic way.
  const observer = new MutationObserver(() => initAll());
  document.addEventListener("DOMContentLoaded", () => {
    const drawer = document.querySelector("cart-drawer");
    if (drawer) observer.observe(drawer, { subtree: true, childList: true });
    // Also watch the cart page main content
    const cartMain = document.querySelector("main");
    if (cartMain) observer.observe(cartMain, { subtree: true, childList: true });
  });
})();

